import { render } from "./index-page.vue?vue&type=template&id=6a716f2a"
import script from "./index-page.vue?vue&type=script&lang=js"
export * from "./index-page.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/main/product/index-page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a716f2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a716f2a', __exports__)) {
    console.log('reload')
    api.reload('6a716f2a', __exports__)
  }
  
  module.hot.accept("./index-page.vue?vue&type=template&id=6a716f2a", () => {
    console.log('re-render')
    api.rerender('6a716f2a', render)
  })

}


export default __exports__